import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { api } from "@/lib/api";
import { flushQueue, queueLength } from "@/lib/offline";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Service worker: registreert de app-shell cache voor offline gebruik.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* geen cache = OK, app werkt nog */ });
  });
}

// Bij terugkeer van verbinding: pending offline acties opnieuw versturen.
window.addEventListener("online", () => {
  if (queueLength() > 0) {
    flushQueue(api).catch(() => { /* fout wordt in-page getoond */ });
  }
});
